import {useState, useEffect} from 'react';
import {isRTL} from '../Localization';
import {isRTLString} from '@priority-software/priority-utils/lib/strings';

export interface IStringDirection {
    forceLtr: boolean;
    forceRtl: boolean;
}

export const useStringDirection = (str: string): IStringDirection => {
    const [result, setResult] = useState({forceLtr: false, forceRtl: false});

    useEffect(() => {
        if (str) {
            const rtl = isRTL();
            const isRtlString = isRTLString(str);
            const forceLtr = rtl && !isRtlString;
            const forceRtl = !rtl && isRtlString;
            setResult({forceLtr, forceRtl});
        }
    }, [str]);

    return result;
};
